import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import Swal from 'sweetalert2';
import { AuthService } from '../_services/auth.service';

@Injectable()
export class StdGuard implements CanActivate {

    constructor(private router: Router, private auth: AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let acc = JSON.parse(localStorage.getItem('currentUser'));

        if (acc && acc.guard == 'Std') {
            return true;
        }

        this.router.navigate(['/reporting/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
